import React, { type FC, useMemo } from 'react'

import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import { ModalConfirm } from 'mailup-web-components'

import {
  modalDeleteDescriptionMap,
  modalDeleteMultiDescriptionMap,
  modalDeleteMultiTitleMap,
  modalDeleteTitleMap,
} from 'Pages/GroupsList/model'
import {
  modalDeleteCancelCallback,
  modalDeleteConfirmCallback,
} from 'Pages/GroupsList/recoil/callbacks/modals'
import { modalDeleteState } from 'Pages/GroupsList/recoil/state/state'

const ModalDelete: FC = () => {
  const intl = useIntl()

  const { op, show, items } = useRecoilValue(modalDeleteState)

  const modalCancel = useRecoilCallback(modalDeleteCancelCallback, [])
  const modalConfirm = useRecoilCallback(modalDeleteConfirmCallback, [])

  const title = useMemo(() => {
    return op !== undefined && Array.isArray(items) && items?.length > 0
      ? items.length === 1
        ? intl.formatMessage(
            {
              id: modalDeleteTitleMap[op],
            },
            {
              NAME: items[0].Name ?? '',
              linebreak: <br />,
            },
          )
        : intl.formatMessage(
            {
              id: modalDeleteMultiTitleMap[op],
            },
            {
              linebreak: <br />,
            },
          )
      : undefined
  }, [intl, op, items])

  const message = useMemo(() => {
    return op !== undefined && Array.isArray(items) && items?.length > 0
      ? items.length === 1
        ? intl.formatMessage(
            {
              id: modalDeleteDescriptionMap[op],
            },
            {
              NAME: items[0].Name ?? '',
              linebreak: <br />,
            },
          )
        : intl.formatMessage(
            {
              id: modalDeleteMultiDescriptionMap[op],
            },
            {
              linebreak: <br />,
            },
          )
      : undefined
  }, [intl, op, items])

  return (
    <ModalConfirm
      show={show}
      showClose
      closeOnOverlayClick
      data-mu-test={`modal-delete__${op ?? ''}`}
      title={title}
      message={message}
      onClickConfirm={modalConfirm}
      onClickCancel={modalCancel}
      stringConfirm={intl.formatMessage({ id: 'Load.MailupCommon.Confirm' })}
      stringCancel={intl.formatMessage({ id: 'Load.MailupCommon.Cancel' })}
    />
  )
}

export default ModalDelete
